/* Resonancy fade-up-on-scroll. Loaded (deferred) by every rsn-* section;
   the guard makes duplicate script tags harmless. Re-arms on Shopify theme
   editor section reloads. Also tags Horizon-native components we want to
   ride the same fade (the email-signup section). */
(function(){
  if(window.__rsnFadeInit) return;
  window.__rsnFadeInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = null;
  if(!reduce && 'IntersectionObserver' in window){
    obs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('visible'); obs.unobserve(en.target); }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -80px 0px'});
  }

  /* Horizon-native sections that should fade like the rsn-* ones */
  function tagExtras(scope){
    (scope || document).querySelectorAll('.email-signup-block').forEach(function(el){
      var sec = el.closest('.shopify-section');
      if(sec && !sec.classList.contains('rsn-fade')) sec.classList.add('rsn-fade');
    });
  }

  function arm(scope){
    tagExtras(scope);
    var els = (scope || document).querySelectorAll('.rsn-fade:not(.visible)');
    for(var i=0;i<els.length;i++){
      if(obs) obs.observe(els[i]);
      else els[i].classList.add('visible');
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ arm(document); });
  } else {
    arm(document);
  }
  /* Theme editor: sections re-render when settings change */
  document.addEventListener('shopify:section:load', function(e){ arm(e.target); });
})();
